module.exports = __webpack_public_path__ + "img/conservative-practitioner-2.13c5298c.svg";